import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from 'designSystem/lib/utils'
import { type ComponentProps } from 'react'

const edgeFadeVariants = cva('pointer-events-none absolute inset-x-0 z-[1]', {
  variants: {
    placement: {
      top: 'top-0',
      below: '-bottom-6',
      bottom: 'bottom-0',
    },
    size: {
      default: 'h-6',
      sm: 'h-3',
    },
  },
  compoundVariants: [{ placement: 'below', size: 'sm', class: '-bottom-3' }],
  defaultVariants: {
    placement: 'bottom',
    size: 'default',
  },
})

function EdgeFade({
  className,
  placement = 'bottom',
  size = 'default',
  ...props
}: ComponentProps<'div'> & VariantProps<typeof edgeFadeVariants>) {
  const fadesDownward = placement === 'below' || placement === 'top'
  return (
    <div
      data-slot='edge-fade'
      aria-hidden
      className={cn(edgeFadeVariants({ placement, size }), className)}
      style={{
        background: fadesDownward
          ? 'linear-gradient(to bottom, var(--edge-fade-from, var(--card)), transparent)'
          : 'linear-gradient(to top, var(--edge-fade-from, var(--card)), transparent)',
      }}
      {...props}
    />
  )
}

export { EdgeFade, edgeFadeVariants }
